import {Grid } from 'react-bootstrap';
import React from 'react';
import './MainView.css';

class Footer extends React.Component{
	render(){
		return(
			<div id="footer">
	        <footer>
	                    <p id="footerText">Copyright &copy; Miami Gardens 2608 LLC. 2017</p>
	        </footer>
	        </div>
		);
	}
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.js